import type {
  ContentModSection,
  ContentModSubSection
} from '~/contracts/common/Seo';

export const sortSectionPriority = (
  a: ContentModSection | ContentModSubSection,
  b: ContentModSection | ContentModSubSection
) => a.sectionPriority - b.sectionPriority;
